import { ActionTypes } from "../../constants/ActionTypes";
import { ILetterRelationReducer, ILetterRelationResponse } from "../../interfaces/LetterRelation";

const INIT_STATE: ILetterRelationReducer = {
  letterRelationList: [],
  checkLetterRelationList: true,
  letterRelationListPageSize: 0,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_LETTER_RELATION: {
      if (action.payload.pageIndex == 0) state.letterRelationList = [];
      return {
        ...state,
        params: action.payload,
        letterRelationListPageSize: action.payload.pageSize,
      };
    }

    case ActionTypes.FETCH_LETTER_RELATION_SUCCESS: {
      let { letterRelationList, letterRelationListPageSize } = state;
      if (action.payload.length < letterRelationListPageSize)
        state.checkLetterRelationList = false;
      letterRelationList = [...letterRelationList, ...action.payload] as ILetterRelationResponse[];
      return {
        ...state,
        letterRelationList,
      };
    }

    default:
      return state;
  }
};
